import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Home from './Home';
import Plan from './Plan';
import { refreshFast, refreshSlow } from './store/AppStore';
import Documents from './components/Documents';
import { clearRedirect } from './store/PersonStore';
import AllocatedUnit from './components/allocatedUnits/AllocatedUnit';
import { StaticMap } from './components/StaticMap';
import { Danish } from 'flatpickr/dist/l10n/da';
import * as flatpickr from 'flatpickr';
import IdleTimer from 'react-idle-timer';
import Login from './components/Login';
import Resource from './components/resource/Resource';
import EventOverview from './components/event/EventOverview';

document.addEventListener('contextmenu', (event) => event.preventDefault());

Date.prototype.getWeek = function () {
    var onejan = new Date(this.getFullYear(), 0, 1);
    return Math.ceil((((this - onejan) / 86400000) + onejan.getDay() + 1) / 7);
};

const App = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { redirectAfterError } = useSelector(state => state.personState);

    // Handle authentication redirects
    useEffect(() => {
        if (redirectAfterError) {
            navigate(redirectAfterError);
            dispatch(clearRedirect());
        }
    }, [redirectAfterError, navigate, dispatch]);

    useEffect(() => {
        flatpickr.default(Danish);

        dispatch(refreshFast());
        dispatch(refreshSlow());

        const refreshInterval = setInterval(() => {
            dispatch(refreshFast());
        }, 1000 * 60 * 2);

        const slowRefreshInterval = setInterval(() => {
            dispatch(refreshSlow());
        }, 1000 * 60 * 15);

        return () => {
            clearInterval(refreshInterval);
            clearInterval(slowRefreshInterval);
        };
    }, [dispatch]);

    const handleIdleAction = () => {
        navigate('/');
    };

    return (
        <div>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/plan/:personId?" element={<Plan />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/map" element={<StaticMap />} />
                <Route path="/login" element={<Login />} />
                <Route path="/resource" element={<Resource />} />
                <Route path="/allocatedUnit" element={<AllocatedUnit />} />
                <Route path="/events" element={<EventOverview />} />
            </Routes>
            <IdleTimer
                element={document}
                onIdle={handleIdleAction}
                timeout={1000 * 60 * 1} // 1 minute
            />
        </div>
    );
};

export default App;